import { adminHttpClient } from '../commons/adminHttpClient'
import { EmployeeDetailsResponse } from './getEmployeeDetails'
import { NamedItemInt } from '../../domain/common/namedItem'
import { ProductAllowance } from '../../domain/product/Product'

export type DataForCreateCompanyForTestingResponse = {
  availableClasTypes: NamedItemInt[]
  availableFamilyStatuses: NamedItemInt[]
  products: ProductInfoForTesting[]
  categories: NamedItemInt[]
}

export type ProductInfoForTesting = {
  id: number
  name: string
  allowance: ProductAllowance
}

export const getDataForCreateCompanyForTesting = (): Promise<DataForCreateCompanyForTestingResponse> => {
  return adminHttpClient.get(`/Companies/DataForCreateCompanyForTesting`, {})
}
